import { routerReducer as routing } from 'react-router-redux';

import attachments from './attachments';
import auth0 from './auth0';
import avatar from './avatar';
import billing from './billing';
import checklist from './checklist';
import comments from './comments';
import company_features from './companyFeatures';
import confirmation_modal from './confirmationModal';
import contact from './contact';
import device from './device';
import dialog_prompt from './dialogPrompt';
import editor from './editor';
import error_bar from './errorBar';
import feature_flags from './featureFlag';
import firstVideoShareModal from './firstVideoShareModal';
import header from './header';
import homepage from './homepage';
import integrations from './integrations';
import layout from './layout';
import login from './login';
import modals from './modals';
import moveModal from './moveModal';
import notification_blocked_prompt from './notificationBlockedPrompt';
import notification_settings from './notificationSettings';
import onboarding from './onboarding';
import preview_panel from './previewPanel';
import reset_password from './reset_password';
import screenshotsDashboard from './screenshotsDashboard';
import searchModal from './searchModal';
import shareScreenshot from './shareScreenshot';
import share_video from './shareVideo';
import slack from './slack';
import splitScreenTakeovers from './splitScreenTakeovers';
import ssoDomainModal from './ssoDomainModal';
import status_bar from './statusBar';
import teamMembers from './team-members';
import textOverlay from './textOverlay';
import transcription from './transcription';
import triggers from './triggers';
import trimming from './trimming';
import upgrades from './upgrades';
import user from './user';
import user_jtbd from './userJtbd';
import video_player from './videoPlayer';
import videos_dashboard from './videosDashboard';
import videoUploads from './videoUploads';
import viewerInsights from './viewerInsights';
import welcome from './welcome';
import workspace from './workspace';

export default {
  attachments,
  auth0,
  avatar,
  billing,
  checklist,
  comments,
  contact,
  company_features,
  confirmation_modal,
  device,
  dialog_prompt,
  editor,
  error_bar,
  feature_flags,
  firstVideoShareModal,
  header,
  homepage,
  integrations,
  layout,
  login,
  modals,
  moveModal,
  notification_blocked_prompt,
  notification_settings,
  onboarding,
  preview_panel,
  reset_password,
  routing,
  searchModal,
  share_video,
  shareScreenshot,
  screenshotsDashboard,
  slack,
  splitScreenTakeovers,
  ssoDomainModal,
  status_bar,
  teamMembers,
  textOverlay,
  transcription,
  triggers,
  trimming,
  upgrades,
  user_jtbd,
  user,
  video_player,
  videos_dashboard,
  videoUploads,
  welcome,
  viewerInsights,
  workspace,
};
